import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import { I18nextProvider } from 'react-i18next';
import App from "./app/App";
import 'react-toastify/dist/ReactToastify.css';
import 'react-loading-skeleton/dist/skeleton.css';
import "./assets/scss/app.scss";
import "./index.css";
import store from "./redux/store";
import i18n from './config/locale/i18n';
import { ToastContainer } from 'react-toastify';


export const persistor = persistStore(store);

const root = ReactDOM.createRoot(document.getElementById("app"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
        <ToastContainer />
      </BrowserRouter>
      </I18nextProvider>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
